module.exports = __webpack_public_path__ + "img/Unterschrift.f94d6546.svg";